import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concat',
})
export class ConcatPipe implements PipeTransform {

  // https://toddmotto.com/angular-pipes-custom-pipes
  transform(values: string[], separator: string = ', '): any {
    let result = ''

    for (const value of values) {
      if (result.length === 0) {
        result = value
      } else {
        result += separator + value
      }
    }

    return result
  }

}
